import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
export function fetchWorkflowDetails(crmObject) {
  const hsFlowId = getPropertyValue(crmObject, 'hs_flow_id');
  return http.get(`automationapps/v1/summaries`, {
    query: {
      flowSource: 'PLATFORM',
      flowIds: hsFlowId,
      includeOptionalEnrollmentCounts: true
    }
  }).then(response => response.results.length ? response.results[0] : undefined);
}
export function fetchWorkflowPerformance(crmObject) {
  return http.post(`events/internal/v0/reports/totals`, {
    data: {
      portalId: PortalIdParser.get(),
      reportType: 'e_workflow_enrollment_report_v2',
      frequency: 'a',
      breakdown: '{properties.hs_automation_flow}',
      breakdownValues: [`${PortalIdParser.get()}-${crmObject.objectTypeId}-${crmObject.objectId}`]
    }
  });
}